import { render, staticRenderFns } from "./BookRoomUnit.vue?vue&type=template&id=704da962&scoped=true"
import script from "./BookRoomUnit.vue?vue&type=script&lang=js"
export * from "./BookRoomUnit.vue?vue&type=script&lang=js"
import style0 from "./BookRoomUnit.vue?vue&type=style&index=0&id=704da962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704da962",
  null
  
)

export default component.exports